import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Users, Phone } from "lucide-react";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/customers").then(r => setItems(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="px-6 lg:px-10 py-8 max-w-7xl mx-auto" data-testid="customers-page">
      <div className="text-xs tracking-[0.2em] uppercase text-zinc-500 mb-2">Directory</div>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tighter font-medium">Customers</h1>
      <p className="text-zinc-400 mt-2 text-sm">Unique customers captured across all your AI agents.</p>

      {loading ? <div className="mt-10 text-zinc-500"><Loader2 className="w-5 h-5 animate-spin"/></div>
        : items.length === 0 ? (
          <div className="mt-10 bg-zinc-950 border border-white/10 rounded-xl p-12 text-center">
            <Users className="w-8 h-8 text-zinc-600 mx-auto mb-3" />
            <div className="font-display text-lg">No customers yet</div>
            <div className="text-zinc-500 text-sm">Customers appear here once they complete an agent chat.</div>
          </div>
        ) : (
          <div className="mt-8 bg-zinc-950 border border-white/10 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-[10px] tracking-[0.2em] uppercase text-zinc-500 border-b border-white/10">
                  <th className="px-5 py-3 font-normal">Name</th>
                  <th className="px-5 py-3 font-normal">Phone</th>
                  <th className="px-5 py-3 font-normal">Source</th>
                  <th className="px-5 py-3 font-normal">Stage</th>
                  <th className="px-5 py-3 font-normal">Last active</th>
                </tr>
              </thead>
              <tbody>
                {items.map((c, i) => (
                  <tr key={c.id} className={`border-b border-white/5 hover:bg-white/5 transition ${i % 2 ? "bg-black/20" : ""}`} data-testid={`customer-${c.id}`}>
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-emerald-500/30 to-emerald-500/5 border border-emerald-500/20 grid place-items-center text-xs font-display">{(c.name || "?")[0].toUpperCase()}</div>
                        <span className="font-medium">{c.name}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3 font-mono text-zinc-400 text-xs flex items-center gap-1"><Phone className="w-3 h-3 text-zinc-600"/>{c.phone || "—"}</td>
                    <td className="px-5 py-3 text-zinc-400 text-xs">{c.source || "—"}</td>
                    <td className="px-5 py-3"><span className="text-xs px-2 py-0.5 rounded-full bg-white/5 border border-white/10 text-zinc-300 capitalize">{c.stage}</span></td>
                    <td className="px-5 py-3 text-zinc-500 text-xs">{c.last_activity ? new Date(c.last_activity).toLocaleString() : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
